import { ortaggi } from "@/data/ortaggi";

// Il calendario interattivo vive dietro filtri in stato React: senza interazione
// la pagina non espone quasi testo. Questa guida deriva dagli stessi dati ma e'
// sempre nel DOM, cosi' la pagina ha contenuto leggibile (da Google e da chi
// arriva senza voglia di smanettare coi filtri).

const MESI = [
  "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
  "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre",
];

const elenco = (nomi: string[]) =>
  nomi.length <= 1
    ? nomi.join("")
    : `${nomi.slice(0, -1).join(", ")} e ${nomi[nomi.length - 1]}`;

const GuidaMensile = () => {
  const mesi = MESI.map((nome, i) => {
    const numero = i + 1;
    const semina = ortaggi
      .filter((o) => o.mesiSemina.includes(numero))
      .map((o) => o.nome)
      .sort((a, b) => a.localeCompare(b));
    const raccolta = ortaggi
      .filter((o) => o.mesiRaccolta.includes(numero))
      .map((o) => o.nome)
      .sort((a, b) => a.localeCompare(b));
    return { nome, numero, semina, raccolta };
  });

  return (
    <section className="bg-background py-12 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Cosa seminare mese per mese
          </h2>
          <p className="text-muted-foreground mb-4">
            I periodi indicati valgono per il centro Italia, la fascia climatica dell'Umbria e
            della zona del Trasimeno. Al nord conviene spostare le semine in campo aperto di
            due o tre settimane piu' avanti, al sud di altrettante piu' indietro. Per le colture
            piu' delicate il semenzaio protetto anticipa di un mese abbondante il trapianto.
          </p>
          <p className="text-muted-foreground mb-10">
            La regola lunare piu' diffusa distingue due casi: in <strong>luna crescente</strong> si
            seminano gli ortaggi da frutto e da seme, perche' la fase favorisce lo sviluppo della
            parte aerea; in <strong>luna calante</strong> si seminano quelli da foglia e da radice,
            che altrimenti tendono a salire a seme troppo presto. Sotto trovi, mese per mese, cosa
            va seminato e cosa arriva a raccolto.
          </p>

          <div className="space-y-8">
            {mesi.map((m) => (
              <article key={m.numero}>
                <h3 className="text-xl font-semibold text-foreground mb-2 capitalize">
                  Cosa seminare a {m.nome}
                </h3>
                {m.semina.length > 0 ? (
                  <p className="text-muted-foreground">
                    A {m.nome} si seminano {elenco(m.semina)}.
                  </p>
                ) : (
                  <p className="text-muted-foreground">
                    A {m.nome} l'orto e' fermo: e' il mese giusto per preparare il terreno,
                    concimare e programmare le semine della stagione successiva.
                  </p>
                )}
                {m.raccolta.length > 0 && (
                  <p className="text-muted-foreground mt-1">
                    Si raccolgono {elenco(m.raccolta)}.
                  </p>
                )}
              </article>
            ))}
          </div>

          <p className="text-muted-foreground mt-10">
            Sementi, piantine da orto, concimi e terricci li trovi in negozio a Magione, in Viale
            Umbria 21. Se hai dubbi su cosa piantare adesso o su che concime serve al tuo terreno,
            passa a trovarci: e' piu' veloce che leggere una tabella.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GuidaMensile;
